module.exports = __webpack_public_path__ + "static/flags/BF-a50172d11f233fddeac30694458d6a97.gif";